import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { addRankPoint } from "../../../features/slices/challanges";
import { useDispatch } from "react-redux";
import { toastService } from "../../../utils/toastify";

const initialState = {
  challengeId: "",
  attendBy: "",
  studentRank: "",
  studentPoints: "5",
  studentName: "",
};

const AddRankPoint = () => {
  const [iState, setUpdateState] = useState(initialState);
  const [errors, setErrors] = useState({});
  const { challengeId, attendBy, studentPoints, studentRank, studentName } =
    iState;
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
console.log(state,"state")
  useEffect(() => {
    if (state) {
      setUpdateState((prev) => ({
        ...prev,
        challengeId: state.challengeId || "",
        attendBy: state.attendBy || "",
        studentName: state.studentData?.fullName || "",
        studentPoints: state.studentPoints || "5",
        studentRank: state.studentRank || "",
      }));
    }
  }, [state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prev) => ({
      ...prev,
      [name]: false,
    }));
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!attendBy?.trim()) {
      formErrors.attendBy = "Student Name is required.";
      isValid = false;
    }
    if (!studentRank || !studentRank.toString()?.trim()) {
      formErrors.studentRank = "Student Rank is required.";
      isValid = false;
    }
    if(studentRank>state?.challengeData?.noOfPrizes){
       formErrors.studentRank = "This Rank does not Exists";
      isValid = false;
    }
    if (!studentPoints || !studentPoints.toString()?.trim()) {
      formErrors.studentPoints = "Student Points is required.";
      isValid = false;
    }
     if (studentPoints < 0) {
      formErrors.studentPoints = "Student Points cannot be in negative";
      isValid = false;
    }
    if (studentPoints > 0 && studentPoints < 5) {
      formErrors.studentPoints = "Student Points cannot be less than 5";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  const handleSubmit = () => {
    const istate={...iState,studentPoints:studentPoints||"5"}
    if (validateForm()) {
      dispatch(addRankPoint(istate)).then((data) => {
        if (data?.payload?.code === 200) {
          toastService.success("Rank & Points added successfully");
          navigate("/challenges/liveSubmissionCompleted/completed", {
            state: challengeId,
          });
        } else {
          toastService.error("Failed to add Rank & Points");
        }
        setUpdateState(initialState);
      });
    }
  };

  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">
              {state?.update ? "Edit Rank" : "Add Rank"} &amp; Points
            </h4>
          </div>
          <div className="CommonForm">
            <div className="form-group">
              <label>Student Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter name"
                name="studentName"
                value={studentName}
                onChange={handleChange}
                disabled
              />
              {errors.studentName && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.studentName}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>Enter Rank</label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter Rank"
                name="studentRank"
                value={studentRank}
                onChange={handleChange}
              />
              {errors.studentRank && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.studentRank}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>Enter Points</label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter Points"
                name="studentPoints"
                value={studentPoints}
                onChange={handleChange}
              />
              {errors.studentPoints && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.studentPoints}
                </p>
              )}
            </div>
          </div>
          <button type="button" className="Button" onClick={handleSubmit}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddRankPoint;
